import React, { useCallback } from 'react'
import cn from 'classnames'
import Menu from '@groovehq/internal-design-system/lib/components/Dropdown/DropdownMenu'
import {
  indicator,
  text,
} from '@groovehq/internal-design-system/lib/styles/elements'
import { SVGIcon } from 'shared/ui'
import { styles } from './styles'

const PresenceDropdownSettingsItem = React.memo(props => {
  const { presence, className, onClick, ...rest } = props
  const handleClick = useCallback(
    () => {
      if (onClick) onClick(presence)
    },
    [onClick, presence]
  )

  return (
    <Menu.Item
      className={cn(className, 'grui py-0 settings')}
      css={styles.settingsItem}
      aria-checked="false"
      onClick={handleClick}
      {...rest}
    >
      <>
        <span css={[indicator.styles.dot, styles.statusDot]} />
        <div className="grui flex flex-1">
          <span
            className="grui flex-grow"
            css={[text.styles.textXs, text.styles.fontSemibold]}
          >
            Auto-away settings
          </span>
          <SVGIcon
            name="angleRightB"
            size={16}
            css={styles.svgStatusDot}
            className="grui self-center"
          />
        </div>
      </>
    </Menu.Item>
  )
})

export default PresenceDropdownSettingsItem
